<div class="page">
  <div class="page-content">
    <nav class="public-header navbar navbar-expand-lg navbar-light fixed-top">
      <img src="../../../../assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}" height="30">
    </nav> <!-- /.navbar -->
    
    <div #card style="position: relative;">
      <mat-card class="custom-card mt-4 mapping-card"
        [ngClass]="{'open-mapping-card': mappaturaOpen || (!mappaturaOpen && !rimappatura), 'closed-mapping-card': !mappaturaOpen && rimappatura}"> <!--  && rimappatura ,  || !rimappatura -->
        <div class="row">
          <div class="col-6">
            <mat-card-title>{{ 'properties.detail.mappingTab.title' | translate }} {{ property?.name }}</mat-card-title>
            <mat-card-subtitle>{{ 'properties.detail.mappingTab.subtitleView' | translate }}</mat-card-subtitle>
          </div>
          <div class="col-6 text-right">
            <button mat-raised-button color="primary" (click)="onViewDocumentNotes()"
              *ngIf="!mappaturaOpen && rimappatura && notesExist" class="mr-2">
              <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="mr-1"></mat-icon>
              {{ 'properties.structures.showNotes' | translate }}
            </button>
          </div>
        </div>
    
        <mat-card-content class="mt-0" [ngClass]="{ 'spinner-area-loading': cardIsLoading }">
          <app-card-spinner [visible]="cardIsLoading" type="zero"></app-card-spinner>
    
          <div class="row">
            <button class="side-menu-toggle-show" mat-stroked-button color="primary" (click)="showSideMenu = false"
              matTooltip="Nascondi menù laterale" matTooltipPosition="right" *ngIf="showSideMenu">
              Nascondi menù
              <mat-icon fontSet="fas" fontIcon="fa-caret-left">
              </mat-icon>
            </button>
            <button class="side-menu-toggle-show" mat-stroked-button color="primary" (click)="showSideMenu = true"
              matTooltip="Mostra menù laterale" matTooltipPosition="right" *ngIf="!showSideMenu">
              Mostra menù
              <mat-icon fontSet="fas" fontIcon="fa-caret-right">
              </mat-icon>
            </button>
          </div>
          <div class="row" *ngIf="!cardIsLoading">
            <div class="side-menu col-12 col-md-5 col-lg-4 mb-5" [ngClass]="{ 'd-none': !showSideMenu }" id="sideMenu">
              <ng-container *ngIf="mappingIndex && mappingIndex.length">
                <mat-accordion class="mapping-index">
                  <ng-container *ngFor="let item of mappingIndex; let i = index;">
    
                    <div class="custom-expansion-panel" *ngIf="checkVisibility(item)"
                      [ngClass]="{'openFirstLevel': item.expanded === true}">
                      <!-- Icon and title accordion -->
                      <a href="javascript:;" class="header-link-wrapper" (click)="onPanelClicked(item, i)">
                        <div class="custom-expansion-panel-header">
                          <div class="custom-expansion-panel-toggle" [ngClass]="{'openFirstLevel': item.expanded === true}">
                          </div>
                          <div class="custom-expansion-panel-header-content">
                            <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon === ''">
                              <mat-icon fontSet="fal" fontIcon="fa-folder" class="mr-3 fa-fw"
                                [ngClass]="{'d-none': item.expanded === true}"></mat-icon>
                              <mat-icon fontSet="fal" fontIcon="fa-folder-open" class="mr-3 fa-fw"
                                [ngClass]="{'d-none': item.expanded === false}"></mat-icon>
                            </div>
                            <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon !== ''">
                              <div *ngIf="item.title !== 'properties.structures.amianto'">
                                <mat-icon fontSet="fal" fontIcon="{{ item.icon }}" class="mr-3 fa-fw"></mat-icon>
                              </div>
                              <div *ngIf="item.title === 'properties.structures.amianto'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="54px" height="54px">
                                  <text font-weight="50" fill="#ec9451" x="19" y="34" font-size="37">a</text>
                                </svg>
                              </div>
                            </div>
                            <strong>
                              <span *ngIf="lang === 'it' && item.translation">{{ item.translation.it }}</span>
                              <span *ngIf="lang === 'en' && item.translation">{{ item.translation.en }}</span>
                            </strong>
                          </div>
                        </div>
                      </a>
    
                      <div class="custom-expansion-panel-content">
                        <div *ngIf="item.content.length">
                          <div *ngFor="let subItem of item.content">
    
                            <ng-container *ngIf="subItem.key === 'anagrafica'">
                              <div class="element no-children-element" [ngClass]="{'active': subItem.active}">
                                <a (click)="activateSection(subItem.section)">
                                  <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                                  <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                                </a>
                              </div>
                            </ng-container>
    
                            <ng-container *ngIf="!subItem.hidden && subItem.type === 'link'
                              && subItem.key !== 'anagrafica'
                              && (mappaturaOpen || (!mappaturaOpen && getChildren(subItem.key).length))">
                              <!-- || (!mappaturaOpen && subItem.key === 'anagrafica' ))"> -->
                              <div matBadge="{{ getChildren(subItem.key).length }}" matBadgePosition="above after"
                                matBadgeColor="primary">
                              </div>
                              <div class="custom-expansion-panel-child"
                                *ngIf="mappaturaOpen || (!mappaturaOpen && getChildren(subItem.key).length)">
                                <a href="javascript:;" class="header-link-wrapper"
                                  (click)="subItem.expanded = !subItem.expanded">
                                  <div class="custom-expansion-panel-header-second">
                                    <div class="custom-expansion-panel-toggle-child"
                                      [ngClass]="{'openSecondLevel': subItem.expanded === true}"></div>
                                    <div class="custom-expansion-panel-header-content-second">
                                      <div class="header-title-wrapper">
                                        <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                                        <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <ul class="custom-expansion-panel-content-list"
                                  [ngClass]="{'openSecondLevel': subItem.expanded === true}">
                                  <li *ngFor="let subSubitem of getChildren(subItem.key)"
                                    [ngClass]="{'active': (model._id === subSubitem._id && subSubitem.active)}"
                                    class="element">
                                    <a *ngIf="subSubitem.active" (click)="onFormItemClick(subItem.section, subSubitem)">
                                      <span *ngIf="subItem.key === 'dipendenti'">{{ subSubitem.nome }}
                                        {{ subSubitem.cognome }} </span>
                                      <span *ngIf="subItem.key === 'impresePulizia'">{{ subSubitem.nomeDitta }}</span>
                                      <!-- <span
                                        *ngIf="subItem.key === 'estintori'">{{ 'properties.structures.estintori' | translate }}</span> -->
                                      <span
                                        *ngIf="subItem.key === 'amianto'">{{ 'properties.structures.amianto' | translate }}</span>
                                      <!-- <span
                                        *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'estintori'">{{ subSubitem.nome }}</span> -->
                                      <span
                                        *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia'">{{ subSubitem.nome }}</span>
                                      <div *ngIf="subItem.key === 'fabbricatoAbitativo' && subSubitem.scale">
                                        <span *ngFor="let scala of subSubitem.scale">{{ scala.nomeScala}}</span>
                                      </div>
                                    </a>
                                  </li>
                                  <li class="new-element-wrapper"
                                    [ngClass]="{ 'active': subItem.active && !formActiveSubitemId && activeItem }" *ngIf="mappaturaOpen
                                      && (subItem.key !== 'amianto'
                                      || (subItem.key === 'amianto'
                                      && !getChildren(subItem.key).length))">
                                    <a title="{{ subItem.buttonTitle | translate  }}"
                                      (click)="activateSection(subItem.section)" class="new-element">
                                      <mat-icon fontSet="fal" fontIcon="fa-layer-plus" class="fa-fw"></mat-icon>
                                      <span>{{ 'properties.structures.newElem' | translate }}</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
    
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
    
                  </ng-container>
                </mat-accordion>
              </ng-container>
            </div> <!-- /.col -->
    
            <div class="col-12" [ngClass]="{ 'side-form-loading': formIsLoading, 'col-md-7 col-lg-8': showSideMenu }" id="strucure-wrapper">
              <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner>
    
              <div class="alert alert-info" *ngIf="!formActiveSection">
                <strong>{{ 'properties.structures.warning' | translate }}</strong> <br>
                <p class="mb-0">
                  {{ 'properties.structures.selectElem' | translate }}
                </p>
              </div>
    
              <div *ngIf="formActiveSection && formActiveSubitemId">
                <div class="row">
                  <div class="col-10">
                    <h4>
                      <span *ngIf="lang === 'it' && activeItem.translation">{{ activeItem.translation.it }}</span>
                      <span *ngIf="lang === 'en' && activeItem.translation">{{ activeItem.translation.en }}</span>
                        {{ model?.nome ? '- ' + model.nome : '' }}
                    </h4>
                  </div>
                  <div class="col-2 text-right">
                    <!-- <button mat-raised-button [matMenuTriggerFor]="menu" color="primary">
                      {{ 'common.cta.actions' | translate }}
                      <mat-icon class="ml-2" fontSet="fas" fontIcon="fa-caret-down"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="onNoteDialog()">
                        <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="primary"></mat-icon>
                        {{ 'properties.structures.showNotes' | translate }}
                      </button>
    
                    </mat-menu> -->
                  </div>
                </div>
    
                <hr>
    
                <div class="form-wrapper mt-3 py-3" *ngIf="!formIsLoading">
                  <!-- <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner> -->
                  <form [formGroup]="form">
                    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
                  </form>
                </div> <!-- /.form-wrapper -->
              </div>
    
              <div *ngIf="!formActiveSubitemId && activeItem">
                <div class="row">
                  <div class="col-12">
                    <h4>{{ 'properties.structures.newElem' | translate }} - 
                      <span *ngIf="lang === 'it' && activeItem.translation">{{ activeItem.translation.it }}</span>
                      <span *ngIf="lang === 'en' && activeItem.translation">{{ activeItem.translation.en }}</span>
                    </h4>
                    <!-- @todo translate. Use: activeItem.title -->
                    <!-- <h5>{{ 'path.to.translation' | translate: }}</h5>
                    "path.to.translation": "Aggiungi un nuovo {{what}}" -->
                  </div> <!-- /.col -->
                </div>
                <hr>
                <div class="form-wrapper mt-3 p-3" *ngIf="!formIsLoading">
                  <form [formGroup]="form">
                    <formly-form [form]="form" [fields]="activeItem.formConfig" [model]="model" [options]="options">
                    </formly-form>
                  </form>
                </div> <!-- /.form-wrapper -->
                <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner>
              </div>
            </div> <!-- /.col -->
          </div> <!-- /.row -->
    
        </mat-card-content>
      </mat-card>
    
    </div>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->